/* Move one drawer instance between header layouts, preserving IDs and controller state. */
(() => {
  const desktop = matchMedia('(min-width: 1024px)');
  const markers = new WeakMap();
  let queued = false;
  function arrange() {
    queued = false;
    document.querySelectorAll('header-component').forEach((header) => {
      const slot = header.querySelector('[data-desktop-drawer-slot]');
      const container = header.querySelector('.header__drawer');
      if (!slot || !container) return;
      if (desktop.matches && !slot.contains(container)) {
        const marker = document.createComment('side-menu-mobile-position');
        container.before(marker);
        markers.set(container, marker);
        slot.append(container);
      } else if (!desktop.matches && slot.contains(container)) {
        const marker = markers.get(container);
        if (marker?.isConnected) {
          marker.after(container);
          marker.remove();
          markers.delete(container);
        }
      }
    });
  }
  const schedule = () => {
    if (queued) return;
    queued = true;
    queueMicrotask(arrange);
  };
  desktop.addEventListener('change', () => {
    document.querySelectorAll('header-drawer').forEach((drawer) => { if (drawer.isOpen) drawer.close(); });
    arrange();
  });
  document.addEventListener('shopify:section:load', arrange);
  new MutationObserver(schedule).observe(document.getElementById('header-group') || document.body, { childList: true, subtree: true });
  arrange();
})();

/* Hover and keyboard focus preview the hovered collection without closing the drawer. */
(() => {
  const desktop = matchMedia('(min-width: 1024px)');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let timer;
  const keyFor = (url) => new URL(url, location.origin).pathname.replace(/\/$/, '');
  const preview = (event) => {
    if (!desktop.matches || !(event.target instanceof Element)) return;
    const target = event.target.closest('.ss-drawer-nav a[href], .ss-drawer-nav summary[data-ss-collection-url]');
    if (!target) return;
    const drawer = target.closest('header-drawer');
    const aside = drawer?.querySelector('.ss-desktop-menu-products');
    const content = aside?.querySelector('[data-ss-preview-content]');
    if (!content) return;
    const url = target.dataset.ssCollectionUrl || target.getAttribute('href');
    const key = keyFor(url);
    const template = [...aside.querySelectorAll('template[data-ss-preview-url]')].find((item) => keyFor(item.dataset.ssPreviewUrl) === key)
      || aside.querySelector('template[data-ss-preview-default]');
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (aside.dataset.activePreview === key) return;
      aside.dataset.activePreview = key;
      drawer.querySelectorAll('[data-preview-active]').forEach((item) => item.removeAttribute('data-preview-active'));
      target.setAttribute('data-preview-active', '');
      content.replaceChildren(template.content.cloneNode(true));
      if (!reduced.matches) {
        content.getAnimations().forEach((animation) => animation.cancel());
        content.animate([{opacity: .2, transform: 'translateY(7px)'}, {opacity: 1, transform: 'translateY(0)'}], {duration: 240, easing: 'ease-out'});
      }
    }, event.type === 'focusin' ? 0 : 90);
  };
  document.addEventListener('pointerover', preview);
  document.addEventListener('focusin', preview);
  document.addEventListener('pointerout', (event) => {
    if (!(event.target instanceof Element)) return;
    const nav = event.target.closest('.ss-drawer-nav');
    if (nav && !nav.contains(event.relatedTarget)) clearTimeout(timer);
  });
})();
